import { Route, Routes } from "react-router-dom";

import { Device } from "./Device";
import { Devices } from "./Devices";

export function DevicesRoutes() {
  return (
    <Routes>
      <Route index element={<Devices />} />
      <Route path=":deviceId/*" element={<Device />} />
    </Routes>
  );
}
